
import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from 'gsap';
import { modulo } from 'libs';
import { modularDistance } from '../../../tools/math/modular-distance';

class EntitySelectorMobile extends AubadeComponent{
	constructor(e, b){
		super(e, b);

		this.entitiesContainer	= this.element.querySelector(".fps-entities-container");
		this.entityPrev		= this.element.querySelector(".fps-entity-left");
		this.entityNext		= this.element.querySelector(".fps-entity-right");
		this.entities 		= [];//Array.from(this.entitiesContainer.querySelectorAll(".fps-entity"));

		this.touchdown = false;
		this.startCoordinates = {x: 0, y: 0}
		this.lastCoordinates  = {x: 0, y: 0}
		this.startProduct = 0;
		this.touchDelta = 0

		this.current = 0
		this.last 	 = 0

		this.lastCode = null

		this.w = 1
	}

	attach() {
		this.viewport.on('resize', this.resize)

		this.entityPrev.addEventListener('click', this.previous)
		this.entityNext.addEventListener('click', this.next)

		this.element.addEventListener('touchstart', this.touchStart)
		this.element.addEventListener('mousedown', this.touchStart)
	}

	detach() {
		this.viewport.off('resize', this.resize)

		this.element.removeEventListener('touchstart', this.touchStart)
		this.element.removeEventListener('mousedown', this.touchStart)

		this.entityPrev.removeEventListener('click', this.previous)
		this.entityNext.removeEventListener('click', this.next)
	}

	get size(){
		return this.entities.length;
	}
	get lastIndex(){
		return this.loopId(this.last);
	}

	get index(){
		return this.loopId(this.current);
	}
	set index(index){
		this.current += modularDistance(
			this.current,
			index,
			this.size
		);
		this.updateLayout();
		if(this.lastCode != this.index){
			this.emit('change', this.code)
			this.lastCode = this.code;
		}
	}

	get code(){
		return this.entities[this.index].getAttribute('data-code');
	}
	set code(code){
		const index = this.entities.findIndex(entity => entity.getAttribute('data-code') == code);
		if(index > -1) this.index = index;
	}


	open(){
		this.resize();

		const t = gsap.timeline();
		t.fromTo(this.element, {opacity:0}, {opacity:1, ease:'none', duration:0.5}, 0);
		return t;
	}
	close(){
		const t = gsap.timeline();
		t.to(this.element, {opacity:0, ease:'none', duration:0.5}, 0);
		return t;
	}

	updateLayout(duration = 0.5, force = false){
		if(this.entities.length == 0) return;

		this.entities.forEach(entity => entity.style.display = "none");

		const t = gsap.timeline();
		this.entities[this.index].style.display = 'block';
		this.entities[this.lastIndex].style.display = 'block';
		t.set(this.entities[this.index], {x: (this.current - this.last) * this.w});
		t.to(this.entities[this.lastIndex], {x: (this.last - this.current) * this.w, duration:duration, ease: 'power2.inOut'}, 0);
		t.to(this.entities[this.index], {x: 0, duration:duration, ease: 'power2.inOut'}, 0);

		t.add(() => this.entities[this.lastIndex].display = 'none');

		this.entityTm = t;

		this.last = this.current
		return t;
	}

	previous = () => {
		this.index--
	}
	next = () => {
		this.index++
	}

	resize = () => {
		this.w = this.element.offsetWidth
		this.updateLayout(0);
	}

	loopId(id) {
		return modulo(id, this.entities.length);
	}


	getTouchCoordinate(e) {
		if(e.clientX && e.clientY) return {x: e.clientX, y: e.clientY}
		else if(e.changedTouches && e.changedTouches.length) {
			return {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY}
		}
		return {x: 0, y: 0}
	}
	touchStart = (e) => {
		this.startCoordinates = this.getTouchCoordinate(e)
		this.startProduct = this.current;

		window.addEventListener('touchend', this.touchEnd, true)
		window.addEventListener('mouseup', this.touchEnd, true)

		window.addEventListener('mousemove', this.touchMove)
		window.addEventListener('touchmove', this.touchMove)
	}
	touchEnd = (e) => {
		const delta = this.touchDelta;
		this.touchDelta = 0;
		if(Math.abs(delta) > 10){
			this.index -= Math.sign(delta)
		}

		window.removeEventListener('touchend', this.touchEnd, true)
		window.removeEventListener('mouseup', this.touchEnd, true)

		window.removeEventListener('mousemove', this.touchMove)
		window.removeEventListener('touchmove', this.touchMove)
	}

	touchMove = (e) => {
		this.lastCoordinates = this.getTouchCoordinate(e);
		this.touchDelta = (this.lastCoordinates.x - this.startCoordinates.x);
		this.updateLayout(0)
	}

	fill(entities) {
		while(this.entitiesContainer.children.length)
			this.entitiesContainer.removeChild(this.entitiesContainer.children[0]) 

		this.entities = [];

		entities.forEach(entity => {
			const elem = document.createElement('div');
			elem.classList.add('fps-entity', 'fps-slide');
			elem.setAttribute('data-code', entity.code);


			const name = document.createElement('div');
			name.classList.add('fps-entity-name');
			name.innerHTML = entity.name;

			const detail = document.createElement('div');
			detail.classList.add('fps-entity-detail');
			detail.innerHTML = entity.legend;

			this.entities.push(elem)

			elem.appendChild(name);
			elem.appendChild(detail);

			this.entitiesContainer.appendChild(elem);
		});

		this.updateLayout(0, true)
	}
}

export { EntitySelectorMobile };
